import { ApolloError } from '@apollo/client';

export const isPaymentMethodInvalidError = (error?: ApolloError) =>
  error && /Argument "payment_method" must be a string/.test(error?.message);
